import { render } from "./Impact__Urengence.vue?vue&type=template&id=8f0a7c44&scoped=true"
import script from "./Impact__Urengence.vue?vue&type=script&lang=js"
export * from "./Impact__Urengence.vue?vue&type=script&lang=js"

import "./Impact__Urengence.vue?vue&type=style&index=0&id=8f0a7c44&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-8f0a7c44"

export default script